import { Link } from 'react-router-dom'
import { Button } from '../../components/ui/Button'
import { Users } from 'lucide-react'
import logo from '../../assets/logo/logo.png'

export default function Register() {
  // Registration is closed until Convex migration is complete
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/20 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo Header */}
        <div className="text-center mb-8">
          <Link to="/" className="relative inline-flex items-center justify-center mb-2" title="Return to home page">
            <img src={logo} alt="2homes.app" className="h-12 w-12 rounded-md shadow-sm" />
          </Link>
          <h1 className="hero-title text-3xl font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 bg-clip-text text-transparent">
            <Link to="/" title="Return to home page">2homes.app</Link>
          </h1>
        </div>

        {/* Registration Closed Notice */}
        <div className="card-glass p-8 text-center">
          <div className="mb-6">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="h-8 w-8 text-blue-600" />
            </div>
            <h2 className="text-2xl font-semibold text-slate-800 mb-3">
              Registration Opens in May
            </h2>
            <p className="text-slate-600 mb-4 leading-relaxed">
              We're preparing an even better experience for you! Registration will reopen in May.
            </p>
            <p className="text-sm text-slate-500">
              Thank you for your interest in 2homes.app. Stay tuned for updates!
            </p>
          </div>

          <div className="pt-4 border-t border-slate-200">
            <p className="text-sm text-slate-600 mb-3">
              Already have an account?
            </p>
            <Link to="/auth/login">
              <Button className="w-full neon-button">
                Sign In
              </Button>
            </Link>
          </div>

          <div className="mt-6">
            <Link
              to="/"
              className="text-sm text-blue-600 hover:text-blue-700 font-medium"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
